module.exports = __webpack_public_path__ + "static/media/css3.b1d1fae6.svg";